import Loadable from 'react-loadable'
import Loading from '../../components/Loading'

export const Profile = Loadable({
  loader: () => import('./containers/Profile'),
  loading: Loading
})

export const EditProfile = Loadable({
  loader: () => import('./containers/EditProfile'),
  loading: Loading
})


// WEBPACK FOOTER //
// ./src/containers/Profile/index.js